import MemberDetails from './MemberDetails';

export default MemberDetails;
